const toBase64Url = (buffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(buffer)
  let binary = ''

  for (let index = 0; index < bytes.byteLength; index++) {
    binary += String.fromCharCode(bytes[index])
  }

  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

const fromBase64Url = (value: string): ArrayBuffer => {
  let padded = value.replace(/-/g, '+').replace(/_/g, '/')

  while (padded.length % 4) { padded += '=' }

  const binary = atob(padded)
  const bytes = new Uint8Array(binary.length)

  for (let index = 0; index < binary.length; index++) {
    bytes[index] = binary.charCodeAt(index)
  }

  return bytes.buffer
}

export const supportsWebAuthn = (): boolean =>
  typeof window.PublicKeyCredential !== 'undefined'

export const decodeCreateOptions = (options: any): PublicKeyCredentialCreationOptions => {
  options.challenge = fromBase64Url(options.challenge)
  options.user.id = fromBase64Url(options.user.id)
  ;(options.excludeCredentials || []).forEach((credential: any) => {
    credential.id = fromBase64Url(credential.id)
  })

  return options as PublicKeyCredentialCreationOptions
}

export const encodeAttestation = (credential: PublicKeyCredential) => {
  const response = credential.response as AuthenticatorAttestationResponse

  return {
    id: credential.id,
    rawId: toBase64Url(credential.rawId),
    type: credential.type,
    response: {
      clientDataJSON: toBase64Url(response.clientDataJSON),
      attestationObject: toBase64Url(response.attestationObject),
    },
  }
}

export const wasCancelled = (error: any): boolean =>
  error?.name === 'NotAllowedError' || error?.name === 'AbortError'

export const decodeGetOptions = (options: any): PublicKeyCredentialRequestOptions => {
  options.challenge = fromBase64Url(options.challenge)

  return options as PublicKeyCredentialRequestOptions
}

export const encodeAssertion = (credential: PublicKeyCredential) => {
  const response = credential.response as AuthenticatorAssertionResponse

  return {
    id: credential.id,
    rawId: toBase64Url(credential.rawId),
    type: credential.type,
    response: {
      clientDataJSON: toBase64Url(response.clientDataJSON),
      authenticatorData: toBase64Url(response.authenticatorData),
      signature: toBase64Url(response.signature),
      userHandle: response.userHandle ? toBase64Url(response.userHandle) : null,
    },
  }
}
